import type { ComboboxItem } from "@mantine/core";
import type { Control, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { Site } from "../../../../../../utils/backend-types";
import { FormFieldController } from "../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { HelperText } from "../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/HelperText";
import { getErrorKeyFromFieldError } from "../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/utils/getErrorKeyFromFieldError";
import type { Contract } from "../../../../DeliveryOverview.types";
import { CONTRACT_FORM_FIELD_DATA } from "../ContractForm.constants";

interface TemplateFieldsProps {
  control: Control<Contract>;
  errors: FieldErrors<Contract>;
  templateContracts: Array<Contract>;
  sites: Array<Site>;
}

function TemplateFields({
  control,
  errors,
  templateContracts,
  sites
}: TemplateFieldsProps) {
  const { t } = useTranslation();
  const templateChoices: Array<ComboboxItem> =
    templateContracts?.map((contract) => {
      return { value: contract.id, label: contract.name };
    }) ?? [];
  const filteredSites = sites?.filter((site) => site.invoicing_active);
  const siteChoices: Array<{ value: number; label: string }> =
    filteredSites?.map((site) => {
      return { value: site.id, label: site.name };
    }) ?? [];
  const templateErrorKey = getErrorKeyFromFieldError(
    errors.creation_template || errors.creation_template_site
  );
  const templateError = templateErrorKey && t(templateErrorKey);

  return (
    <div className="TemplateFields">
      <FormFieldController
        control={control}
        data={{
          ...CONTRACT_FORM_FIELD_DATA.creation_template,
          data: templateChoices
        }}
      />
      <FormFieldController
        control={control}
        data={{
          ...CONTRACT_FORM_FIELD_DATA.creation_template_site,
          data: siteChoices
        }}
      />
      <HelperText error={templateError} />
    </div>
  );
}

export { TemplateFields };
